/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import React from 'react'
import Task from './Task/index'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/ActiveStep/Automation/EventActions/Content/Action"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventActionTypeValueData = fromData.useDataFormat({ viewPath,
context: 'event_action',
path: 'type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventActionTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Task'}>
<Task
  viewPath={`${viewPath}/Task`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}